<template>
  <div class="searchLicense">
    <el-form :inline="true" :model="searchForm" ref="searchForm" :rules="searchRules" v-show="showSearchBox">
      <h1>Search License</h1>
      <el-form-item prop="searchType">
        <el-select v-model="searchForm.searchType" placeholder="Please Select">
          <el-option label="License ID (Outer)" value="license_id"></el-option>
          <el-option label="Customer" value="customer"></el-option>
          <el-option label="Project" value="project"></el-option>
          <el-option label="ER Number" value="er_num" :formatter="arrayFormat"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="searchQuery">
        <el-input v-model="searchForm.searchQuery" class="input-with-select" maxlength="30" @keyup.enter.native="onClickSearch">
          <el-button slot="append" icon="el-icon-search" @click="onClickSearch()" :loading="searching"></el-button>
        </el-input>
      </el-form-item>
    </el-form>

    <el-table v-show="showLicenseRecord || searching" :data="licenseRecordData" empty-text="No Record Found" v-loading="searching"
              :cell-style="{textAlign: 'center'}"
              border style="width: 100%" :header-cell-style="{textAlign: 'center', background: '#E5E7E9'}">
      <el-table-column fixed prop="outerlicense" label="Outer License"></el-table-column>
      <el-table-column prop="interlicense" label="Inter License"></el-table-column>
      <el-table-column prop="er_num" label="ER Number"></el-table-column>
      <el-table-column prop="license_content" label="License Content" :formatter="jsonFormat"></el-table-column>
      <el-table-column prop="lic_type" label="License Type" :formatter="licTypeFormat"></el-table-column>
      <el-table-column prop="project" label="Project Name"></el-table-column>
      <el-table-column prop="direct_cus" label="Direct Customer"></el-table-column>
      <el-table-column prop="user_email" label="Customer Email"></el-table-column>
      <el-table-column prop="exp_date" label="Expiry Date [as UTC(+00:00)]" :formatter="dateFormat"></el-table-column>
      <el-table-column prop="ser_exp_date" label="Service Support Expiry Date [as UTC(+00:00)]" :formatter="dateFormat"></el-table-column>

      <el-table-column fixed="right" label="Operation" empty-text="No Record Found" width="200">
        <template slot-scope="scope">
          <el-button-group v-show="showLicenseRecord">
            <!-- <el-button type="primary" icon="el-icon-message" @click="onClickView(scope.row)"></el-button>-->
            <el-button type="primary" plain icon="el-icon-edit" @click="onClickModify(scope.row)"></el-button>
            <el-button type="primary" plain icon="el-icon-delete" @click="onClickDelete(scope.row)"
                       v-if="userType === 1"></el-button>
            <el-button type="primary" plain icon="el-icon-download" @click="onClickDownload(scope.row)" :loading="downloading"></el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page=curPage
      layout="total, prev, pager, next, jumper"
      :total=numOfData>
    </el-pagination>

  </div>
</template>

<script>
import {searchLicense, downloadLicense, getLicenseList, searchLicenseByPage} from '../api'
import moment from 'moment'
export default {
  data () {
    return {
      searching: false,
      downloading: false,
      licenseRecordData: [],
      showLicenseRecord: false,
      showSearchBox: true,
      numOfData: 0,
      numOfPage: 0,
      curPage: 1,
      userType: 0,
      searchForm: {
        searchType: 'license_id',
        searchQuery: ''
      },
      searchRules: {
        searchQuery: [
          { required: true, message: 'Please Enter the Search Query', trigger: 'blur' }
        ],
        searchType: [
          { required: true, message: 'Please Select a Search Type', trigger: 'blur' }
        ]
      }
    }
  },
  created: function () {
    this.searching = false
    this.showSearchBox = true
    this.showLicenseRecord = false
    this.userType = this.$store.state.usertype

    console.log('$store usertype = %d', this.$store.state.usertype)
    console.log('usertype = %d', this.userType)

    this.getDataList()
  },
  mounted: function () {

  },
  methods: {
    getDataList () {
      let that = this
      that.searching = true
      getLicenseList().then(data => {
        console.log('getLicenseList Succeed')
        console.log(data)

        that.licenseRecordData = data.license_record
        that.numOfData = data.count
        that.numOfPage = data.pagecount
        that.curPage = 1
        that.showLicenseRecord = true
        that.searching = false
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        that.searching = false
      })
    },
    handleCurrentChange (val) {
      let that = this
      that.searching = true
      searchLicenseByPage(that.searchForm.searchType, encodeURIComponent(that.searchForm.searchQuery), val).then(data => {
        console.log('searchLicenseByPage Succeed')
        console.log(data)

        that.licenseRecordData = data.license_record
        that.numOfData = data.count
        that.numOfPage = data.pagecount
        that.curPage = val
        that.showLicenseRecord = true
        that.searching = false
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        that.searching = false
      })
    },
    onClickView (row) {
      console.log(row)
    },
    onClickSearch () {
      let that = this
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          that.searching = true
          console.log('onClick Search')
          console.log('search type = ', that.searchForm.searchType)
          console.log('search query = ', that.searchForm.searchQuery)

          searchLicense(that.searchForm.searchType, encodeURIComponent(that.searchForm.searchQuery)).then(data => {
            that.searching = false
            that.licenseRecordData = data.license_record
            that.numOfData = data.count
            that.numOfPage = data.pagecount
            that.curPage = 1

            console.log('searchLicense Succeed')
            console.log(data)

            that.showLicenseRecord = true
            that.showSearchBox = true
          }).catch(error => {
            if (error) {
              console.log(error.stack)
            }
            that.searching = false
          })
        }
      })
    },
    onClickDownload (row) {
      this.downloading = true
      console.log('onClick Download')
      console.log('outerlicense')
      console.log(row.outerlicense)
      console.log('interlicense')
      console.log(row.interlicense)

      downloadLicense(row.outerlicense, row.interlicense).then(data => {
        var fileURL = window.URL.createObjectURL(new Blob([data]))
        var fileLink = document.createElement('a')
        var fileName = 'license_' + row.outerlicense + '.lic'

        this.downloading = false

        fileLink.href = fileURL
        fileLink.setAttribute('download', fileName)
        document.body.appendChild(fileLink)

        fileLink.click()
      })
    },
    onClickDelete (row) {
      console.log('Route to DeleteLicense')
      console.log(row)
      this.$router.push({name: 'DeleteLicense', params: {data: row}})
    },
    onClickModify (row) {
      console.log('Route to ModifyLicense')
      this.$router.push({name: 'ModifyLicense', params: {data: row}})
    },
    // Format Timestamps
    dateFormat: function (row, column) {
      let date = row[column.property]
      if (date === -1) {
        return 'No Limit'
      }
      if (date === null) {
        return ''
      }
      if (date === undefined) {
        return ''
      }
      return moment.utc(date).format('YYYY-MMM-DD', true)
    },
    jsonFormat: function (row, column, cellValue, index) {
      var jsonObj = cellValue
      if (jsonObj === undefined) {
        return ''
      }
      const jsonStr = JSON.stringify(jsonObj)
      return jsonStr
    },
    licTypeFormat: function (row, column) {
      let licType = row[column.property]
      switch (licType) {
        case 0: return 'Web'
        case 1: return 'Local'
        default: return 'Unknown Type'
      }
    },
    arrayFormat: function (row, column) {
      var arrayInput = row[column.property]
      if (arrayInput === undefined) {
        return ''
      }
      if (Array.isArray(arrayInput)) {
        return arrayInput.join()
      } else {
        return arrayInput
      }
    }
  }
}
</script>

<style>
.el-select .el-input {
  width: 180px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>

<style>
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// Search.vue?7346ba8e